export default "/_next/static/images/section-7-69ba766e1cacd6c7ea678cd794a80fe3.png";